import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

const baseClasses =
  'w-full rounded-md border bg-[var(--field-surface)] px-3 py-2 text-base ' +
  'text-[var(--text-primary)] placeholder:text-[var(--text-muted)] ' +
  'transition-colors duration-fast ease-standard focus-visible:border-[var(--field-focus-border)] ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--field-focus-ring)] ' +
  'disabled:cursor-not-allowed disabled:bg-[var(--field-surface-disabled)] disabled:opacity-60';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, invalid = false, rows = 4, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        aria-invalid={invalid || undefined}
        className={cn(
          baseClasses,
          invalid
            ? 'border-[var(--danger-border)]'
            : 'border-[var(--border-subtle)] hover:border-[var(--border-strong)]',
          className,
        )}
        {...rest}
      />
    );
  },
);
